exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nbutton[data-v-309a2680] {\n  color: #FFFFFF;\n  background: rgb(245, 136, 165);\n  background: linear-gradient(90deg, rgba(245, 136, 165, 1) 0%, rgba(245, 144, 160, 1) 35%, rgba(249, 170, 137, 1) 100%);\n}\n", ""]);

